import React, { useEffect } from "react";
import Black_video from "../../assets/black-adamant.mp4";
import "./fullscreenVideo.css";

const FullscreenVideo = () => {
  useEffect(() => {
    const video = document.getElementById("videoPlayer");
    video.play();
  }, []);

  return (
    <div className="video_main_container">
      <div className="video_container container">
        <div className="video_player">
          <video
            id="videoPlayer"
            width="100%"
            height="100%"
            playsInline
            autoPlay
            muted
          >
            <source src={Black_video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>
  );
};

export default FullscreenVideo;
